function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DominicanRepublicFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_4264",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_4264)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#C51918"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_4264",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_4264)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5 3H13.5V10.5H24V13.5H13.5V21H10.5V13.5H0V10.5H10.5V3Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("rect", {
        y: "3",
        width: "10.5",
        height: "7.5",
        fill: "#4257BF"
      }), /*#__PURE__*/_jsx("rect", {
        x: "13.5",
        y: "13.5",
        width: "10.5",
        height: "7.5",
        fill: "#4257BF"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.2277 11.333L10.9743 11.4045C10.8465 12.7396 11.0125 13.3021 11.2824 13.3021V14.0521C10.3491 14.0521 10.0609 13.0758 10.2277 11.333Z",
        fill: "#309404"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.82 11.333L13.0734 11.4045C13.2012 12.7396 13.0351 13.3021 12.7653 13.3021V14.0521C13.6986 14.0521 13.9868 13.0758 13.82 11.333Z",
        fill: "#309404"
      }), /*#__PURE__*/_jsx("rect", {
        x: "11.0454",
        y: "11.0192",
        width: "0.709091",
        height: "1.10769",
        fill: "#003994"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.1364 12.3346H12.8454V13.0787C12.8454 13.2795 12.6826 13.4423 12.4818 13.4423H12.1364V12.3346Z",
        fill: "#003994"
      }), /*#__PURE__*/_jsx("rect", {
        x: "12.0818",
        y: "10.95",
        width: "0.70909",
        height: "1.10769",
        fill: "#DE2110"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.0454 12.3346H11.7545V13.4423H11.4091C11.2082 13.4423 11.0454 13.2795 11.0454 13.0787V12.3346Z",
        fill: "#DE2110"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.7508 10.957L10.2491 10.3995C10.7789 9.92283 11.331 9.675 11.8996 9.675C12.4683 9.675 13.0204 9.92283 13.5501 10.3995L13.0485 10.957C12.6473 10.596 12.2663 10.425 11.8996 10.425C11.533 10.425 11.152 10.596 10.7508 10.957Z",
        fill: "#00319C"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.8054 14.6955L10.3037 14.138C10.8335 13.6613 11.3856 13.4135 11.9542 13.4135C12.5228 13.4135 13.0749 13.6613 13.6047 14.138L13.103 14.6955C12.7018 14.3345 12.3208 14.1635 11.9542 14.1635C11.5876 14.1635 11.2066 14.3345 10.8054 14.6955Z",
        fill: "#DE2110"
      })]
    })]
  })]
}));
//# sourceMappingURL=DominicanRepublic.js.map